import styled from 'styled-components'

export const ExplanationText = styled.p`
  max-width: 75%;
  margin: auto;
  margin-top: 32px;
  line-height: 30px;
  letter-spacing: 0.29px;
  text-align: center;
  + p {
    margin-top: 0px;
    margin-bottom: 40px;
  }
`

export const ColorDest = styled.span`
  color: var(--color-primary-01);
  font-weight: bold;
`

export const Spacing = styled.div`
  margin-top: 36px;
`

export const ProgressPosition = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 700px;
`

export const FileUploadWrapper = styled.div`
  padding-bottom: 32px;
`

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;
  label {
    margin-right: 8px;
    text-align: center;
  }
`

export const LastOrder = styled.span`
  text-decoration: underline;
  color: var(--color-primary-01);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 16px;
  margin-right: 32px;
  flex: 1;
  align-items: flex-end;
  padding-bottom: 16px;
  button {
    max-width: 150px;
  }
`
